// src/components/admin/design/FeaturedProductsPreview.tsx
"use client";

import UniversalProductCardPreview from "./UniversalProductCardPreview";

export interface PreviewProps {
  variantId: string;
  primaryColor?: string;
  theme?: "dark" | "light";
  subdomain?: string;
}

export default function FeaturedProductsPreview({
  variantId = "motion_3d",
  primaryColor = "#059669",
  theme,
  subdomain,
}: PreviewProps) {
  return (
    <UniversalProductCardPreview
      sectionTitle="Featured Products"
      variantId={variantId}
      primaryColor={primaryColor}
      theme={theme}
      subdomain={subdomain}
    />
  );
}